import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NtCompany } from '../../models/nt-company';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from '../../../../services/company.service';

@Component({
  selector: 'app-company-base',
  templateUrl: './company-base.component.html',
  styleUrls: ['./company-base.component.scss']
})
export class CompanyBaseComponent implements OnInit {
    @Input() useContainer = false;
    @Output() companyAvailable = new EventEmitter<NtCompany>();
    loaded = false;
    sub = new Subject();
    version = 0;

    constructor(private comp: CompanyService) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(takeUntil(this.sub))
            .subscribe(c => {
                if(c){
                    this.loaded = true;
                    this.version = c.companyVersion;
                    this.companyAvailable.emit(c);
                }
            });
    }

    ngOnDestroy(): void {
        this.sub.next(false);
        this.sub.complete();
    }
}
